export default __webpack_public_path__ + "static/media/banner_home.6d5d7864.png";